import { teacherProfileAtom } from '@openeducation/oe-it-jotai-atoms';
import { useEnvironmentContext } from '@openeducation/oe-it-providers';
import { useAtomValue } from 'jotai';
import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';

import { MessageItem } from '../interfaces/message-notification';
import { QueryKeys } from '../interfaces/query-keys';
import { MessageService } from '../services/message.service';

export function useMessages() {
  const { environment } = useEnvironmentContext();
  const teacherProfile = useAtomValue(teacherProfileAtom);

  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(1);

  const onPagination = (page: number, itensPerPage: number) => {
    setPage(page);
    setItemsPerPage(itensPerPage);
  };
  const { data, isLoading, error } = useQuery<MessageItem[]>(
    [QueryKeys.Messages, teacherProfile?.id, page, itemsPerPage],
    () =>
      MessageService.getMessages(
        environment,
        teacherProfile?.id,
        page,
        itemsPerPage
      ),
    { enabled: !!teacherProfile?.id, refetchOnWindowFocus: true }
  );

  const { mutateAsync: remove, isLoading: isRemoving } = useMutation(
    (id: string) => {
      return MessageService.remove(environment, id, teacherProfile?.id);
    }
  );

  return {
    data,
    error,
    isLoading,
    remove,
    isRemoving,
    onPagination,
    pagination: {
      page,
      itemsPerPage,
    },
  };
}
